// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".metric-title{cursor:help;padding:2px 6px;border-radius:4px;transition:background-color .2s ease;display:inline-flex;align-items:center}.metric-title:hover{background-color:rgba(0,0,0,.05)}.copyable-value{cursor:pointer}.copyable-value:hover{opacity:.7}", ""]);
// Exports
module.exports = exports;
